import { QueryCache, useQueryClient } from '@tanstack/react-query';
import { DATA_QUERY_PLUGIN_KEY, UnknownSpec } from '../../core';
import { GetDataResponse } from '../model/queries';

/**
 * Get active time series queries for query results summary
 */
export function useActiveTimeSeriesQueries() {
  const queryClient = useQueryClient();
  const queryCache = queryClient.getQueryCache();
  return getActiveTimeSeriesQueries(queryCache);
}

/**
 * Filter all cached queries down to only active time series queries
 */
export function getActiveTimeSeriesQueries(cache: QueryCache) {
  const queries = [];
  for (const query of cache.findAll({ type: 'active' })) {
    const firstPart = query.queryKey?.[0] as UnknownSpec;
    if (firstPart.startsWith(DATA_QUERY_PLUGIN_KEY)) {
      const queryData = query.state.data as GetDataResponse<'TimeSeries'>;
      if (queryData?.type && queryData.type === 'TimeSeries') {
        queries.push(queryData.data);
      }
    }
  }
  return queries;
}
